
const w = (window as any);

export const YouTubeIframe = {

    async init() {

        // If this exists we are already loaded
        if (w.onYouTubeIframeAPIReady) {
            return Promise.resolve();
        }

        return new Promise<void>((rs, rj) => {

            w.onYouTubeIframeAPIReady = () => {
                rs();
            };

            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        });
    }
}